import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { apiLogin, apiRegister, apiMe } from '../lib/api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem('tv_auth_token');
    if (!t) { setLoading(false); return; }
    try {
      const data = await apiMe();
      setUser(data.user);
      setBrand(data.brand);
    } catch {
      localStorage.removeItem('tv_auth_token');
      setUser(null); setBrand(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const res = await apiLogin({ email, password });
    localStorage.setItem('tv_auth_token', res.token);
    setUser(res.user); setBrand(res.brand);
    return res;
  };
  const register = async (email, password, brand_name) => {
    const res = await apiRegister({ email, password, brand_name });
    localStorage.setItem('tv_auth_token', res.token);
    setUser(res.user); setBrand(res.brand);
    return res;
  };
  const logout = () => {
    localStorage.removeItem('tv_auth_token');
    setUser(null); setBrand(null);
  };

  return (
    <AuthCtx.Provider value={{ user, brand, setBrand, loading, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
